import {
  getResponseById,
  GetResponseByIdRequestParams,
} from "@/requests/questionnaries/response-by-id.request";
import { Choice, ChoiceType } from "@/types/questionnaries";
import { useQuery } from "@tanstack/react-query";

export const buildAnswerByResponseIdQueryKey = (
  variables: GetResponseByIdRequestParams,
) => [
  "companies",
  variables.companyId,
  "quiz",
  variables.quizId,
  "responses",
  variables.responseId,
  "answers",
];

/**
 * Get the answers and choices of a question
 */
export const useAnswerByResponseId = (
  variables: GetResponseByIdRequestParams,
  isEnabled: boolean = true,
) => {
  const queryKey = buildAnswerByResponseIdQueryKey(variables);

  return useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const question = await getResponseById(variables, signal);

      // Build a fake root choice to be able to use the composite choice
      const fakeRootChoice: Choice = {
        id: question.id,
        statement: "",
        answerMode: question.answerMode,
        choices: question.choices,
        label: question.statement,
        selected: true,
        type: ChoiceType.Composite,
      };

      return fakeRootChoice;
    },
    enabled: Object.values(variables).every(Boolean) && isEnabled,
  });
};
